import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { logoutIcon, mainLogo } from '@/assets/images'
import { DashboardPage } from './DashboardPage'
import { DashboardOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons'
import './index.less'
import { OverViewPage } from './OverViewPage'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { AnalysisPage } from './AnalysisPage'
import { setAuthority, setToken, setUserId } from '@/features/Login/login'
import { Button, message, Modal } from 'antd'
import { getLikesList, getWorkListByTags, saveResult } from '@/server'
import { setOverviewList, setTotal } from '@/features/SetOverviewTypeList/setOverviewTypeList'
import { tag2criteria } from './SearchBox'
import { LikesPage } from './LikesPage'
import {
  setIdList,
  setLikesNowPage,
  setLikesTotal
} from '@/features/SetLikesPageList/setLikesPageList'
import { setGlobalTags } from '@/features/SetSixLawsInfo/setSixLawsInfo'
import { setSelectedPage } from '@/features/SetAnalysisImageInfo/setAnalysisImageInfo'
import SegmentContext from '@/components/SegmentHelpers/hooks/createContext'
import { imageToBase64 } from '@/components/SegmentHelpers/maskUtils'

export function ProfessionPage() {
  const {
    isSaving: [, setIsSaving]
  } = useContext(SegmentContext)!
  const dispatch = useAppDispatch()
  // 缓存的画作浏览历史页面(nowPage)和画作收藏的历史页面(nowLikesPage)
  const nowPage = useAppSelector((state) => state.overviewTypeList.nowPage)
  const nowLikesPage = useAppSelector((state) => state.likesPageList.nowPage)
  // 缓存的workId和imageId
  const workId = useAppSelector((state) => state.analysisImageInfo.workId)
  const imageId = useAppSelector((state) => state.analysisImageInfo.imageId)
  //缓存的当前六法全局信息和历史六法全局信息
  const globalTags = useAppSelector((state) => state.sixLawsInfo.globalTags)
  const historyGlobalTags = useAppSelector((state) => state.sixLawsInfo.historyGlobalTags)
  // 缓存的tagsList和keyword
  const tagsList = useAppSelector((state) => state.overviewTagsList.tagsList)
  const keyword = useAppSelector((state) => state.overviewTagsList.keyword)
  const userId = useAppSelector((state) => state.login.userId)
  const token = useAppSelector((state) => state.login.token)
  // 浏览(0)/表单(1)模式
  const selectedType = useAppSelector((state) => state.overviewTypeList.selectedType)
  // 0:数据概览 1:画作选择 2:画作分析  3:个人收藏页
  const [component, setComponent] = useState(0)
  // 标注保存
  const selectedPage = useAppSelector((state) => state.analysisImageInfo.selectedPage)
  const {
    stickers: [stickers],
    isChanging: [isChanging, setIsChanging]
  } = useContext(SegmentContext)!
  const [isSegmentModalOpen, setIsSegmentModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const handleSave = async () => {
    setLoading(true)
    const data = stickers.map((sticker) => {
      let name = sticker.name
      if (name == null) name = 'undefined'
      return { ...sticker, img: imageToBase64(sticker.img), name: name }
    })
    saveResult({ data: data, name: `${imageId}_${userId}.png` })
      .then((_response: any) => {
        message.success({
          content: '保存成功!'
        })
        setLoading(false)
        setIsSegmentModalOpen(false)
      })
      .catch((error) => {
        message.warning({
          content: '保存失败！' + error
        })
        setLoading(false)
        setIsSegmentModalOpen(false)
      })
    setIsChanging(false)
  }
  const segmetnHandleOk = () => {
    handleSave()
  }
  const segmetnHandleCancel = () => {
    setIsChanging(false)
    setIsSegmentModalOpen(false)
  }
  //数据概览modal
  const [isDashboardModalOpen, setIsDashboardModalOpen] = useState(false)
  const dashboardHandleOk = () => {
    setIsDashboardModalOpen(false)
    dispatch(setGlobalTags(historyGlobalTags))
    setComponent(0)
  }
  const dashboardHandleCancel = () => {
    setIsDashboardModalOpen(false)
  }
  // 画作选择页modal
  const [isOverviewPageModalOpen, setIsOverviewPageModalOpen] = useState(false)
  const overviewPageHandleOk = () => {
    setIsOverviewPageModalOpen(false)
    dispatch(setGlobalTags(historyGlobalTags))
    //整理数据
    const dataObj: {
      keyword: string
      criteria: { key: string; value: string[] }[]
      pages: { page: number; size: number }
    } = {
      keyword: keyword,
      criteria: [],
      pages: {
        page: nowPage,
        size: selectedType === 0 ? 8 : 14
      }
    }
    for (const key in tagsList) {
      if (tagsList[key].length > 0) {
        dataObj.criteria.push({ key: tag2criteria[key], value: tagsList[key] })
      }
    }
    getWorkListByTags(token, dataObj).then((res) => {
      if (res.data.code === '10056') {
        //token失效
        window.confirm('登录已过期，请重新登录！')
        dispatch(setToken(''))
        navigate('/')
      } else {
        const list = res.data.content.list.map((item) => {
          return {
            workId: item.workid,
            workName: item.workname,
            museum: item.instname,
            mediaType: item.mediatype,
            materialType: item.materialtype,
            styleType: item.styletype,
            horizontal: item.horizontal,
            vertical: item.vertical,
            authorName: item.authorname,
            dynasty: item.dynasty,
            class1: item.class1,
            class2: item.class2,
            src: item.encoding,
            tilesPath: item.tilesPath
          }
        })
        dispatch(setTotal(res.data.content.total))
        dispatch(setOverviewList(list))
      }
    })

    setComponent(1)
  }
  const OverviewPageHandleCancel = () => {
    setIsOverviewPageModalOpen(false)
  }
  //个人收藏页modal
  const [isLikesPageModalOpen, setIsLikesPageModalOpen] = useState(false)
  const likesPageHandleOk = () => {
    setIsLikesPageModalOpen(false)
    dispatch(setGlobalTags(historyGlobalTags))
    dispatch(setLikesNowPage(nowLikesPage))
    getLikesList(token, { page: nowLikesPage, size: 10 }).then((res) => {
      if (res.data.code === '10056') {
        //token失效
        window.confirm('登录已过期，请重新登录！')
        dispatch(setToken(''))
        navigate('/')
      } else {
        // 获取该用户的收藏页数
        dispatch(setLikesTotal(Math.ceil(res.data.content.total / 10)))
        // 更新idList
        dispatch(setIdList(res.data.content.list))
      }
    })
    setComponent(3)
  }
  const likesPageHandleCancel = () => {
    setIsLikesPageModalOpen(false)
  }
  //主页modal
  const [isBackHomeModalOpen, setIsBackHomeModalOpen] = useState(false)
  const backHomeHandleOk = () => {
    setIsBackHomeModalOpen(false)
    dispatch(setGlobalTags(historyGlobalTags))
    if (token) navigate('/index')
    else navigate('/')
  }
  const backHomeHandleCancel = () => {
    setIsBackHomeModalOpen(false)
  }
  //退出modal
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false)
  const logoutHandleOk = () => {
    setIsLogoutModalOpen(false)
    dispatch(setGlobalTags(historyGlobalTags))
    dispatch(setAuthority(-1))
    dispatch(setToken(''))
    dispatch(setUserId(''))
    navigate('/')
    message.success('退出成功！')
  }
  const logoutHandleCancel = () => {
    setIsLogoutModalOpen(false)
  }

  const navigate = useNavigate()
  /**
   * 返回主页回调
   */
  const handleBackHome = () => {
    if (JSON.stringify(globalTags) !== JSON.stringify(historyGlobalTags)) {
      setIsBackHomeModalOpen(true)
    } else {
      if (token) navigate('/index')
      else navigate('/')
    }
  }
  /**
   * 登出回调
   */
  const handleLogout = () => {
    if (JSON.stringify(globalTags) !== JSON.stringify(historyGlobalTags)) {
      setIsLogoutModalOpen(true)
    } else {
      dispatch(setAuthority(-1))
      dispatch(setToken(''))
      dispatch(setUserId(''))
      navigate('/')
      message.success('退出成功！')
    }
  }
  const selectOverview = () => {
    setIsSaving(true) //分割系统重置
    if (JSON.stringify(globalTags) !== JSON.stringify(historyGlobalTags)) {
      setIsOverviewPageModalOpen(true)
    } else {
      //整理数据
      const dataObj: {
        keyword: string
        criteria: { key: string; value: string[] }[]
        pages: { page: number; size: number }
      } = {
        keyword: keyword,
        criteria: [],
        pages: {
          page: nowPage,
          size: selectedType === 0 ? 8 : 14
        }
      }
      for (const key in tagsList) {
        if (tagsList[key].length > 0) {
          dataObj.criteria.push({ key: tag2criteria[key], value: tagsList[key] })
        }
      }
      getWorkListByTags(token, dataObj).then((res) => {
        if (res.data.code === '10056') {
          //token失效
          window.confirm('登录已过期，请重新登录！')
          dispatch(setToken(''))
          navigate('/')
        } else {
          const list = res.data.content.list.map((item) => {
            return {
              workId: item.workid,
              workName: item.workname,
              museum: item.instname,
              mediaType: item.mediatype,
              materialType: item.materialtype,
              styleType: item.styletype,
              horizontal: item.horizontal,
              vertical: item.vertical,
              authorName: item.authorname,
              dynasty: item.dynasty,
              class1: item.class1,
              class2: item.class2,
              src: item.encoding,
              tilesPath: item.tilesPath
            }
          })
          dispatch(setTotal(res.data.content.total))
          dispatch(setOverviewList(list))
        }
      })
      setComponent(1)
    }
  }
  /**
   * 跳转画作分析页面的回调
   * @returns null
   */
  const handlePaintingAnalysis = () => {
    if (!workId && !imageId) {
      message.warning('您还未有画作选择记录，无法进行画作分析！')
      return
    }
    dispatch(setSelectedPage(0))
    setComponent(2)
  }
  /**
   * 跳转画作标注页面的回调
   * @returns null
   */
  const _handleSegmentPage = () => {
    if (!workId && !imageId) {
      message.warning('您还未有画作选择记录，无法进行画作分析！')
      return
    }
    dispatch(setSelectedPage(0))
    setComponent(3)
  }
  /**
   * 跳转收藏页面的回调
   */
  // const handleLikesPage = () => {
  //   if (JSON.stringify(globalTags) !== JSON.stringify(historyGlobalTags)) {
  //     setIsLikesPageModalOpen(true)
  //   } else {
  //     dispatch(setLikesNowPage(nowLikesPage))
  //     getLikesList(token, { page: nowLikesPage, size: 10 }).then((res) => {
  //       if (res.data.code === '10056') {
  //         //token失效
  //         window.confirm('登录已过期，请重新登录！')
  //         dispatch(setToken(''))
  //         navigate('/')
  //       } else {
  //         // 获取该用户的收藏页数
  //         dispatch(setLikesTotal(Math.ceil(res.data.content.total / 10)))
  //         // 更新idList
  //         dispatch(setIdList(res.data.content.list))
  //       }
  //     })
  //     setComponent(4)
  //   }
  // }
  // 图像标注保存
  useEffect(() => {
    if (isChanging && (component != 2 || selectedPage != 6)) {
      setIsSegmentModalOpen(true)
    }
  }, [isChanging, component, selectedPage])
  // 关闭窗口弹窗提示
  useEffect(() => {
    window.addEventListener('beforeunload', alertUser)
    return () => {
      window.removeEventListener('beforeunload', alertUser)
    }
  })
  const alertUser = (event: any) => {
    if (JSON.stringify(globalTags) !== JSON.stringify(historyGlobalTags)) {
      event.preventDefault()
      event.returnValue = 'aaa'
    }
  }
  return (
    <div className='profession-container'>
      <div className='profession-header-container'>
        <div className='profession-header-title'>
          <img src={mainLogo} alt='大标题' onClick={handleBackHome} />
        </div>
        <div className='profession-header-menu'></div>
        <div className='profession-header-btn'>
          <div className='profession-logo' title='退出登录' onClick={handleLogout}>
            <img src={logoutIcon} alt='退出登录' />
          </div>
        </div>
      </div>
      <div className='profession-body-container'>
        <div className='profession-body-menu'>
          <div className='buttons-container'>
            <button
              className={component === 0 ? 'sider-button sider-button-clicked' : 'sider-button'}
              onClick={() => {
                if (JSON.stringify(globalTags) !== JSON.stringify(historyGlobalTags)) {
                  setIsDashboardModalOpen(true)
                } else {
                  setComponent(0)
                }
              }}
            >
              &nbsp;
              <DashboardOutlined />
              <span className='button-text'>数据概览</span>
            </button>
            <button
              className={component === 1 ? 'sider-button sider-button-clicked' : 'sider-button'}
              onClick={selectOverview}
            >
              &nbsp;
              <EyeOutlined />
              <span className='button-text'>画作选择</span>
            </button>
            <button
              className={component === 2 ? 'sider-button sider-button-clicked' : 'sider-button'}
              onClick={handlePaintingAnalysis}
            >
              &nbsp;
              <EditOutlined />
              <span className='button-text'>画作分析</span>
            </button>
            {/*<button*/}
            {/*  className={component === 3 ? 'sider-button sider-button-clicked' : 'sider-button'}*/}
            {/*  onClick={handleLikesPage}*/}
            {/*>*/}
            {/*  &nbsp;*/}
            {/*  <UserOutlined />*/}
            {/*  <span className='button-text'>个人收藏页</span>*/}
            {/*</button>*/}
          </div>
        </div>
        <div className='profession-body-content'>
          {component === 0 ? (
            <DashboardPage />
          ) : component === 1 ? (
            <OverViewPage setComponent={setComponent} />
          ) : component === 2 ? (
            <AnalysisPage />
          ) : component === 3 ? (
            <LikesPage setComponent={setComponent} />
          ) : (
            <></>
          )}
        </div>
      </div>
      <Modal
        open={isDashboardModalOpen}
        onOk={dashboardHandleOk}
        onCancel={dashboardHandleCancel}
        closable={false}
      >
        <p>画作标签存在改动，是否仍要切换界面至数据概览？</p>
      </Modal>
      <Modal
        open={isOverviewPageModalOpen}
        onOk={overviewPageHandleOk}
        onCancel={OverviewPageHandleCancel}
        closable={false}
      >
        <p>画作标签存在改动，是否仍要切换界面至画作选择？</p>
      </Modal>
      <Modal
        open={isLikesPageModalOpen}
        onOk={likesPageHandleOk}
        onCancel={likesPageHandleCancel}
        closable={false}
      >
        <p>画作标签存在改动，是否仍要切换界面至个人收藏页？</p>
      </Modal>
      <Modal
        open={isBackHomeModalOpen}
        onOk={backHomeHandleOk}
        onCancel={backHomeHandleCancel}
        closable={false}
      >
        <p>画作标签存在改动，是否仍要切换界面至主页？</p>
      </Modal>
      <Modal
        open={isLogoutModalOpen}
        onOk={logoutHandleOk}
        onCancel={logoutHandleCancel}
        closable={false}
      >
        <p>画作标签存在改动，是否仍要退出登录？</p>
      </Modal>
      <Modal
        open={isSegmentModalOpen}
        onOk={segmetnHandleOk}
        onCancel={segmetnHandleCancel}
        closable={false}
        footer={[
          <Button type='primary' key='save' loading={loading} onClick={segmetnHandleOk}>
            保存
          </Button>,
          <Button key='nosave' onClick={segmetnHandleCancel}>
            不保存
          </Button>
        ]}
      >
        <p>图像标注存在改动，是否保存？</p>
      </Modal>
    </div>
  )
}
